import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  selectBasketcustomerOrderDetail: "selectBasketcustomerOrderDetail [Action]",
  selectBasketcustomerOrderDetailLoading:
    "selectBasketcustomerOrderDetailLoading [Action]",
  selectBasketcustomerOrderDetailAsync:
    "selectBasketcustomerOrderDetailAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  size: 100,
  total: 10000,
};

export const select_basketcustomer_order_detail_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectBasketcustomerOrderDetail:
      return {
        ...state,
        data: payload?.results,
        total: payload.total
          ? payload.total > 10000
            ? 10000
            : payload.total
          : 0,
      };
    case actionTypes.selectBasketcustomerOrderDetailLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectBasketcustomerOrderDetailLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "portfolio",
    method_type: "select_basketcustomer_order_detail",
    data: payload?.data ? payload.data : {},
    from: payload.from,
    size: payload.size,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectBasketcustomerOrderDetail,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectBasketcustomerOrderDetailLoading,
      payload: false,
    });
  }
}

export function* selectBasketcustomerOrderDetail() {
  yield takeLatest(
    actionTypes.selectBasketcustomerOrderDetailAsync,
    handleWorker
  );
}
